export enum EnumTipoRefacturacion {
  AnuladoraNueva = 1,
  Diferencia,
  AjusteProxima,
  Anuladora,
  Regeneradora
}
